// extracted by mini-css-extract-plugin
export var modalFooter = "_pm-0";